import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import BasicModal       from '@partials/basic-modal';
import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';

// -------------------------------------------------------


class MainAction extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      entry_url: null,
    };
  }
  // -------------------------------------------------------
  
  createEntryUrl() {
    let detail = this.props.detail;
    
    let chk = confirm('エントリー用のURLを発行しますか？');
    if( chk == false ) return;
    
    Utils.request.bind(this)('/api/project/influencer/create_entry_url', { project_id: detail.project_id, insta_user_id: detail.insta_user_id },
      function(res){
        this.setState({ entry_url: res.body.url });
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  croseEntryUrl() {
    this.setState({ entry_url: null });
  }
  // -------------------------------------------------------
  
  render() {
    let detail = this.props.detail;
    
    // アクション
    if( detail.workflow_status.is_assign == 1 ){
      return (
        <div>
          <li className="on" onClick={this.createEntryUrl.bind(this)}>
            {this.props.button}
          </li>
          
          {(this.state.entry_url != null) &&
            <BasicModal
              modal_active={true}
              title = "インフルエンサー エントリー用URL"
              sub_title = {<span className="alert">{Moment().add(7, 'days').format('YYYY年M月D日')} に有効期限が切れます。ご注意ください。</span>}
              width = {600}
              contents = {
                <div>
                  <a href={this.state.entry_url} target="_blank">{this.state.entry_url}</a>
                </div>
              }
              contents_height = {60}
              buttons = {
                [{ id: 'yes', name: '閉じる', event: this.croseEntryUrl.bind(this)}]
              }
            />
          }
        </div>
      );
    }
    
    // 使用できない
    return (
      <OverlayTrigger placement="left" delayShow={50} overlay={<Tooltip>案件依頼をしていない場合は、<br />エントリー用のURLを発行できません</Tooltip>}>
        <li className="off">
          {this.props.button}
        </li>
      </OverlayTrigger>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default MainAction;